
export default {
  name: 'AppSelectButton',
  props: {
    value: { type: [String, Number], default: null },
    options: { type: Array, required: true }
  }
};
